import { Component, OnInit, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermissionService } from '../../user/user-permission/user-permission.service';
import { readOnly } from '../../user/user-permission/user-permission.data';
import { EntityData, HorizontalListData } from 'common';
import { BankLinkingInfoWidgetAdapter } from './bank-linking-info-widget.data';
import { VerificationStatus } from '../bank.model';

@UntilDestroy()
@Component({
    selector: 'ifb-bank-linking-info-widget',
    templateUrl: './bank-linking-info-widget.component.html',
    styleUrls: ['./bank-linking-info-widget.component.scss'],
    providers: [BankLinkingInfoWidgetAdapter],
    standalone: false
})
export class BankLinkingInfoWidgetComponent implements OnInit {
  private canReadBankAccountVerificationStatus: boolean;

  listItems: HorizontalListData[];

  readonly VerificationStatus = VerificationStatus;

  @Input()
  entity: EntityData;

  constructor(
    private readonly userPermissionService: UserPermissionService,
    private readonly adapter: BankLinkingInfoWidgetAdapter
  ) { }

  ngOnInit(): void {
    this.userPermissionService.granted([readOnly('servicing-bank-accounts-verification')])
      .pipe(untilDestroyed(this))
      .subscribe(res => {
        this.canReadBankAccountVerificationStatus = res;
        this.listItems = this.adapter.adaptListData(this.entity, this.canReadBankAccountVerificationStatus);
      });
  }
}
